import { render, staticRenderFns } from "./coreBoxWithEdit.vue?vue&type=template&id=0ebb6e48"
import script from "./coreBoxWithEdit.vue?vue&type=script&lang=js"
export * from "./coreBoxWithEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports